import React from 'react';
import PageSeo from '@/seo/PageSeo';
import PricePlan from '../components/Pricings/PricePlanes';

function Plans() {
  return (
    <React.Fragment>
      <PageSeo
        title="Plans for the Gene-Disease Association Database | DISGENET"
        description="Academic and commercial plans for DISGENET, the curated gene-disease association database used in target identification and precision medicine."
        path="/plans"
      />
      <PricePlan />
    </React.Fragment>
  );
}

export default Plans;
